import api from '@/api'
import Vue from 'vue';
import permissions from '@/api/permissions'
import _ from 'lodash'

class RetendModel
{
  _findPaymentTypeAndNum(paymentId) {
    let num = paymentId;
    let payType = 'Type1';
    let type = 'contract';

    if (num > this.datePointContract) {
      num -= this.datePointContract;
      payType = 'Type2';
      type = 'delivery';

      if (num > this.datePointDelivery) {
        num -= this.datePointDelivery;
        payType = 'Type3';
        type = 'accept';
      }
    }

    return {
      num,
      payType,
      type
    }
  }

  _createPayment(partId, paymentId) {
    const payment = {
      ...this._findPaymentTypeAndNum(paymentId),
      paymentId,
      part: partId,
      days: {
        value: api.Number.fromAPI(),
        precision: new api.Precision()
      },
      percent: {
        value: api.Number.fromAPI(),
        precision: new api.Precision()
      }
    };

    return payment;
  };

  _createPart(partId) {
    const payments = Array.from({length: this.numberOfPayments}, (v, i) => this._createPayment(partId, i + 1));

    const part = {
      partId: partId,
      part: partId,
      check: false,
      date: undefined,
      payments,
      deliveryDate: {
        value: api.Date.fromAPI(),
        precision: new api.Precision()
      },
      receiveDate: {
        value: api.Date.fromAPI(),
        precision: new api.Precision()
      },
      paymentDays: {
        value: api.paymentDays,
        precision: new api.Precision()
      }
    };

    return part;
  }

  static fromAPI(data) {
    const model = new RetendModel();

    const retend = data.retend;
    const lot = data.lot;
    const deltaTime = data.deltaTime;

    Object.assign(model, {
      lot: {
        id: retend.lotId,
        num: retend.lotNum,
        name: retend.lotName,
        email: retend.email
      },
      state: new api.RetendState(retend.state),
      changeDescription: retend.description,
      willBeSentForApproval: !!retend.needCommit,
      reason: retend.reason,
      antisniper: api.Number.fromAPI(retend.antisniper),
      showAntisniper: !!retend.showAntisniper,
      methods: lot.methods,
      num: retend.no,
      isFilled: !!retend.filled,
      startTime: retend.timeBegin ? new Date(retend.timeBegin) : undefined,
      endTime: retend.timeEnd ? new Date(retend.timeEnd) : undefined,
      serverDeltaTime: deltaTime,
      currency: new api.Currency(retend.currency),
      step: retend.step,
      waitingTime: retend.waitingTime,
      permissions: permissions.init(retend.permissions),
      showOptions: {
        ownPrice: !!retend.showOptions.showOwnPresentPrice,
        ownEstimation: !!retend.showOptions.showOwnEstimate,
        ownRating: !!retend.showOptions.showOwnRating,
        competitorPrice: !!retend.showOptions.showOtherPresentPrice,
        competitorEstimation: !!retend.showOptions.showOtherEstimate
      },
      numberOfParts: retend.parts || 0,
      numberOfPayments: retend.countPay || 0,
      specs: retend.specifications || [],
      parts: _.sortBy(retend.payments.map(e => ({
        part: e.partNum,
        cost: 0,
        currency: new api.Currency(undefined),
        deliveryDate: api.Date.fromAPI(e.deliveryDate),
        deliveryMaxDays: e.deliveryMaxDays,
        minDeliveryDate: e.deliveryMaxDays && retend.timeBegin ? new Date(retend.timeBegin + (retend.contractDays + e.deliveryMaxDays) * 24 * 3600 * 1000) : undefined,
        acceptingDate: api.Date.fromAPI(e.receiveDate)
      })), 'part'),
      compareMode: retend.compare ? new api.CompareMode('normal') : new api.CompareMode('average'),
      contractDays: retend.contractDays,
      checkDates: retend.checkDates,
      dates: retend.dates.map((e, i) => retend.checkDates[i] && e ? +e : undefined),

      datePointContract: api.Number.fromAPI(retend.datePointContract),
      datePointDelivery: api.Number.fromAPI(retend.datePointDelivery),
      datePointReceive: api.Number.fromAPI(retend.datePointReceive)
    });

    if (!model.endTime && model.startTime) {
      model.endTime = model.startTime;
    }

    model.numberOfAdditionalParts = 0;
    model.specs = model.specs.map(e => {
      const item = {
        dismiss: !!e.dismiss,
        catalog: {
          id: e.nomenalture,
          name: e.name
        },
        okei: e.okei,
        okeiName: e.okeiName,
        parentPosition: e.parentPosition || 0,
        isAdditional: e.request !== 0,
        additionalPart: e.request !== 0 && e.parentPosition === 0,
        checkDate: e.checkDate,
        position: e.position,
        additionalNomenclature: e.additionNomen,
        isNew: !!e.newPosition,
        count: e.count,
        price: e.price,
        multiplier: api.Number.fromAPI(e.multiplier),
        presentPrice: e.presentPrice,
        bidCurrency: _.map(e.bidCurrency, c => new api.Currency(c)),
        payCurrency: _.map(e.payCurrency, c => new api.Currency(c)),
        currencyClause: new api.CurrencyClauseOptional(e.currencyClause),
        syndicate: e.syndicate || undefined,
        winner: e.winner,
        percent: e.percent,
        reason: e.reason,
        parts: (e.parts||[]).map((e, i) => ({part: i + 1, serial: i + 1, count: e})),

        request: e.request,
        bidNum: e.bidNum,
        organization: e.organization
      };

      if (item.additionalPart) {
        ++model.numberOfAdditionalParts;
      }

      return item;
    });

    model.specs = model.specs.sort((a, b) => {
      const av = [a.request, a.bidNum];
      const bv = [b.request, b.bidNum];

      if (a.parentPosition !== 0 && b.parentPosition !== 0) {
        // sort by parent position
        return a.parentPosition - b.parentPosition;
      }

      av.unshift(a.parentPosition || a.position);
      bv.unshift(b.parentPosition || b.position);

      for (let i = 0; i < av.length; ++i) {
        if (av[i] !== bv[i]) return av[i] - bv[i];
      }

      return 0;

      // const d = a.parentPosition - b.parentPosition;
      // if (d === 0) return a.position - b.position;
      // if (b.parentPosition && a.parentPosition) return d;
      // if (b.parentPosition === 0) return a.parentPosition - b.position;
      // return a.position - b.parentPosition;
    });

    const specForAdditionalParts = model.specs.filter(e => e.additionalPart);

    let part = model.numberOfParts + 1;
    model.specs.reduce((acc, e) => {
      if (e.parentPosition === 0) {
        acc.major++;
        acc.minor = 0;
      }
      else acc.minor++;

      e.serial = acc.major;
      if (acc.minor) {
        e.serial += '.' + acc.minor;
      }

      if (e.isAdditional && e.parentPosition === 0) {
        // set proper part
        const serverPart = _.find(retend.requestParts, { position: e.position }) || {};
        e.parts = [{ part: serverPart.part, serial: part++, count: e.count}];
      }
      else if (e.isAdditional) {
        const parent = _.find(model.specs, s => {
          let valid = s.position === e.parentPosition;

          if (valid && s.request) {
            valid = valid && s.request === e.request && s.bidNum === e.bidNum
          }

          return valid;
        });
        e.parts = parent.parts;
        e.count = parent.count;
        e.percent = parent.percent;
      }

      return acc;
    },{major: 0, minor: 0});

    model.parts = Array.from({length: part - 1}, (v, i) => ({idx: i}));

    // fill parts
    model.parts.forEach(part => {
      let obj;
      if (part.idx < model.numberOfParts) {
        part.part = part.idx + 1;
        obj = _.find(retend.payments, { partNum: part.part }) || {};
      }
      else {
        const specItem = specForAdditionalParts[part.idx - model.numberOfParts];
        part.part = _.find(retend.payments, { position: specItem.position}).partNum;
        part.isAdditional = true;
        part.position = specItem.position;
        part.request = specItem.request;
        part.bidNum = specItem.bidNum;
        obj = _.find(retend.payments, { partNum: part.part, request: part.request, bidNum: part.bidNum, position: part.position }) || {};
      }

      part.serial = part.idx + 1;
      part.check = retend.checkDates[part.idx];
      part.date = api.Date.fromAPI(retend.dates[part.idx]);
      part.commonReceiveDate = api.Date.fromAPI(retend.receiveDates[part.idx]);

      const payments = Array.from({length: model.numberOfPayments}, (v, i) => i + 1).map(paymentId => {
        const payment = model._createPayment(part.part, paymentId);
        let pay;

        if (!part.request) {
          pay = _.find(retend.paymentPartsDo, {
            payType: payment.payType,
            num: payment.num,
            part: part.part}
          ) || {};
        }
        else {
          pay = _.find(retend.paymentPartsDo, {
            payType: payment.payType,
            num: payment.num,
            part: part.part,
            request: part.request,
            bidNum: part.bidNum
          }) || {};
        }

        return {
          ...payment,
          days: {
            value: api.Number.fromAPI(pay.days, 0),
            precision: new api.Precision(!!pay.daysExactly),
          },
          percent: {
            value: api.Number.fromAPI(pay.prc, 0),
            precision: new api.Precision(!!pay.prcExactly),
          }
        }
      });

      _.extend(part, {
        partId: part.serial,
        ...obj,
        payments,

        deliveryMaxDays: obj.deliveryMaxDays,
        minDeliveryDate: obj.deliveryMaxDays && retend.timeBegin ? new Date(retend.timeBegin + (retend.contractDays + obj.deliveryMaxDays) * 24 * 3600 * 1000) : undefined,

        deliveryDate: {
          value: api.Date.fromAPI(obj.deliveryDate),
          precision: new api.Precision(!!obj.deliveryDateExactly)
        },
        receiveDate: {
          value: api.Date.fromAPI(obj.receiveDate),
          precision: new api.Precision(!!obj.receiveDateExactly)
        },
        paymentDays: {
          value: api.Number.fromAPI(obj.deliveryDays, 0),
          precision: new api.Precision(!!obj.deliveryDaysExactly)
        }
      });
    });

    const deliveryTypes = retend.deliveryTypes || [];
    const paymentTypes = retend.paymentTypes || [];

    model.schedule = {
      deliveryTypes: deliveryTypes.map(r => ({
        startDate: api.Date.fromAPI(r[2]),
        fromPart: api.Number.fromAPI(r[0]),
        toPart: api.Number.fromAPI(r[1])
      })),
      paymentTypes: paymentTypes.map(r => ({
        startDate: api.Date.fromAPI(r[2]),
        fromPart: api.Number.fromAPI(r[0]),
        toPart: api.Number.fromAPI(r[1])
      }))
    };

    model.applyRules(model.schedule, { fromServer: true });

    return model;
  }

  applyRules(rules, opts = {}) {
    _.extend(this.schedule, rules);

    for (const rule of this.schedule.deliveryTypes) {
      let startDate = rule.startDate;
      const dayOfMonth = startDate.getDate();

      for (let partId = rule.fromPart; partId <= rule.toPart; ++partId) {
        const part = this.parts[partId - 1];
        part.minDeliveryDate = startDate;
        part.minDeliveryDateByRules = part.minDeliveryDate;

        let day = 31;
        let month = startDate.getMonth();

        if (dayOfMonth !== 1 && partId == rule.toPart) {
          day = dayOfMonth - 1;
        }

        let finishDate = startDate;
        do {
          finishDate = new Date(startDate.getFullYear(), month, day);
          day--;
        } while (finishDate.getMonth() > month);

        if (!opts.fromServer) {
          part.check =  true;
          part.date = finishDate;
          part.commonReceiveDate = finishDate;
          part.paymentDays.value = 0;
          part.paymentDays.precision = new api.Precision(api.Precision.NOT_WORSE);

          // if (part.check) {
          //   if (part.date) {
          //     part.deliveryDate.value = part.date;
          //     part.deliveryDate.precision = new api.Precision(api.Precision.EXACTLY);
          //   }
          //
          //   if (part.commonReceiveDate) {
          //     part.receiveDate.value = part.commonReceiveDate;
          //     part.receiveDate.precision = new api.Precision(api.Precision.EXACTLY);
          //   }
          // }
        }

        startDate = new Date(finishDate.getFullYear(), finishDate.getMonth() + 1, 1);
      }
    }

    for (const rule of this.schedule.paymentTypes) {
      let date = rule.startDate;
      const part = this.parts[rule.fromPart - 1];
      part.minPaymentDate = date;

      if (!opts.fromServer) {
        for (let part = rule.fromPart; part <= rule.toPart; ++part) {
          _.filter(this.parts[part - 1].payments, {type: 'contract'}).map(p => {
            p.days.value = 0;
            p.days.precision = new api.Precision(api.Precision.NOT_WORSE);
            p.percent.value = 0;
            p.percent.precision = new api.Precision(api.Precision.NOT_WORSE);
          });
        }
      }
    }
  }

  recalc() {
    const totalParts = this.numberOfParts + this.numberOfAdditionalParts;
    const oldNumberOfParts = this.parts.length - this.numberOfAdditionalParts;

    // update parts in spec in according to new numberOfParts values
    let additionalPartSerial = this.numberOfParts + 1;
    for (let i = 0; i < this.specs.length; ++i) {
      // update part serial for position generating additional part
      if (this.specs[i].additionalPart) {
        // always the one part
        this.specs[i].parts[0].serial = additionalPartSerial++;
        continue;
      }

      // if number of parts is decreased, then just remove the difference
      if (this.specs[i].parts.length > this.numberOfParts) {
        this.specs[i].parts.splice(this.numberOfParts, this.specs[i].parts.length - this.numberOfParts);
      }
      else if (this.specs[i].parts.length < this.numberOfParts) {
        // fill new part in spec with 0

        const newParts = Array.from({
          length: this.numberOfParts - this.specs[i].parts.length
        }, (v, i) => ({
          part: i + oldNumberOfParts + 1,
          serial: i + oldNumberOfParts + 1,
          count: 0
        }));

        this.specs[i].parts = this.specs[i].parts.concat(newParts);
      }
    }

    // remove all out-of-range rules
    this.schedule.deliveryTypes = _.filter(this.schedule.deliveryTypes, e => e.toPart <= totalParts);
    this.schedule.paymentTypes = _.filter(this.schedule.paymentTypes, e => e.toPart <= totalParts);

    // update parts in spec in according to new numberOfParts & numberOfPayments values
    // if number of parts is decreased, then just remove the difference
    if (this.parts.length > totalParts) {
      this.parts.splice(this.numberOfParts, this.parts.length - totalParts);
    }
    else if (this.parts.length < totalParts) {
      // should add shared parts only
      const newParts = Array.from({
        length: totalParts - this.parts.length
      }, (v, i) => this._createPart(oldNumberOfParts + i + 1));
      this.parts = this.parts
        .slice(0, oldNumberOfParts)
        .concat(newParts)
        .concat(this.parts.slice(oldNumberOfParts));
    }

    // we should resize payments array in every part, recalc payment type and update part serial
    for (let idx = 0; idx < this.parts.length; ++idx) {
      const part = this.parts[idx];
      part.partId = idx + 1;

      if (part.payments.length > this.numberOfPayments) {
        part.payments.splice(this.numberOfPayments, part.payments.length - this.numberOfPayments);
      }
      else if (part.payments.length < this.numberOfPayments) {
        const newPayments = Array.from({
          length: this.numberOfPayments - part.payments.length
        }, (v, i) => this._createPayment(part.partId, part.payments.length + i + 1));
        part.payments = part.payments.concat(newPayments);
      }

      for (const payment of part.payments) {
        _.extend(payment, this._findPaymentTypeAndNum(payment.paymentId));

        if (this. numberOfPayments === 1) {
          payment.percent = {
            value: 10000,
            precision: new api.Precision(api.Precision.EXACTLY)
          }
        }
      }
    }
  }

  toAPI() {
    let compareMode = this.compareMode;

    if (typeof compareMode === 'string') {
      compareMode = new api.CompareMode(compareMode)
    }

    const json = {
      timeBegin: +this.startTime || undefined,
      timeEnd: +this.endTime || undefined,
      step: this.step,
      waitingTime: this.waitingTime,
      parts: this.numberOfParts,
      countPay: this.numberOfPayments,
      currency: this.currency.valueOf(),
      compare: !!compareMode.NORMAL,
      antisniper: api.Number.toAPI(this.antisniper),
      showAntisniper: !!this.showAntisniper,
      description: this.changeDescription,

      datePointContract: api.Number.toAPI(this.datePointContract),
      datePointDelivery: api.Number.toAPI(this.datePointDelivery),
      datePointReceive: api.Number.toAPI(this.datePointReceive),

      showOptions: {
        showOwnPresentPrice: this.showOptions.ownPrice,
        showOwnEstimate: this.showOptions.ownEstimation,
        showOwnRating: this.showOptions.ownRating,
        showOtherPresentPrice: this.showOptions.competitorPrice,
        showOtherEstimate: this.showOptions.competitorEstimation
      },

      deliveryTypes: this.schedule.deliveryTypes.map(e => [api.Number.toAPI(e.fromPart), api.Number.toAPI(e.toPart), api.Date.toAPI(e.startDate, 0)]),
      paymentTypes: this.schedule.paymentTypes.map(e => [api.Number.toAPI(e.fromPart), api.Number.toAPI(e.toPart), api.Date.toAPI(e.startDate, 0)]),

      specifications: this.specs.map(e => ({
        nomenclature: e.catalog && e.catalog.id || undefined,
        count: e.count,
        okei: e.okei || undefined,
        price: e.price,
        parts: (e.isAdditional ? undefined: e.parts.map(p => api.Number.toAPI(p.count))),
        percent: !!e.percent,
        bidCurrency: e.bidCurrency.map(item => api.Enum.toAPI(item)),
        payCurrency: e.payCurrency.map(item => api.Enum.toAPI(item)),
        currencyClause: api.Enum.toAPI(e.currencyClause),
        parentPosition: e.parentPosition,
        position: e.position,
        request: e.request,
        bidNum: e.bidNum
      })),

      payments: this.parts.map(p => ({
        partNum: p.part,
        position: p.position,
        request: p.request,
        bidNum: p.bidNum,
        deliveryDate: api.Date.toAPI(p.deliveryDate.value),
        deliveryDateExactly: p.deliveryDate.precision.valueOf(),
        receiveDate: api.Date.toAPI(p.receiveDate .value), // currency receiveDate always equals to deliveryDate
        receiveDateExactly: p.receiveDate.precision.valueOf(),
        deliveryDays: api.Number.toAPI(p.paymentDays.value),
        deliveryDaysExactly: p.paymentDays.precision.valueOf(),
      })),

      paymentPartsDo: this.parts.reduce((acc, p) => {
        p.payments.reduce((items, e) => {
          // skip empty records
          if (!e.days.value && !e.days.precision.valueOf() &&
            !e.percent.value && !e.percent.precision.valueOf()) return items;

          items.push({
            part: p.part,
            payType: e.payType,
            num: e.num,
            request: p.request,
            bidNum: p.bidNum,
            days: api.Number.toAPI(e.days.value),
            daysExactly: e.days.precision.valueOf(),
            prc: api.Number.toAPI(e.percent.value),
            prcExactly: e.percent.precision.valueOf()
          });

          return items;
        }, acc);

        return acc;
      }, []),

      dates: this.parts.map(p => api.Date.toAPI(p.date, 0)),
      receiveDates: this.parts.map(p => api.Date.toAPI(p.commonReceiveDate, 0)),
      checkDates: this.parts.map(p => !!p.check)
    };

    // Форма формирования лота. Даты поставок добавить правила при указании соответствующих комбинаций:
    // 1. Нет галки в чекбоксе дата.
    //     Правило: Участник в предложении указывает срок поставки в календарных днях от даты заключения договора.
    //     А организатор в при формировании переторжки устанавливает общие для всех предложений даты поставки и дату приемки по качеству.
    //     При этом Дата поставки не должна быть ранее даты, вычесленной по формуле:
    //       Дата переторжки+ КД на заключение договора + КД поставки из худшего по этому значению предложения
    // 2. Есть только галка в чекбоксе дата.
    //     Правило: Участник в предложении указывает срок поставки в календарных днях от даты заключения договора, дату поставки и дату приёмки по качеству.
    // 3. Есть галка в чекбоксе дата. и орг указал даты поставки и дату приемки по качеству.
    //     Правило:Участник в предложении не указывает ничего.
    //     Срок поставки в календарных днях не рассчитывается.
    //     Дата поставки и дата приёмки по качеству равны указанной дате.

    // we should cleanup payments field depending on checkDates and date
    json.payments.forEach((p, idx) => {
      if (json.dates[idx]) {
        p.deliveryDays = 0;
        p.deliveryDaysExactly = false;
        p.deliveryDate = 0;
        p.deliveryDateExactly = false;
      }

      if (json.receiveDates[idx]) {
        p.deliveryDays = 0;
        p.deliveryDaysExactly = false;
        p.receiveDate = 0;
        p.receiveDateExactly = false;
      }

      if (!json.checkDates[idx]) {
        p.deliveryDays = 0;
        p.deliveryDaysExactly = false;
      }

      // if (!json.checkDates[p.partNum - 1] && !json.dates[p.partNum - 1]) {
      //   // if checkDate and date are not set, user can only set deliveryDays & deliveryDaysExactly,
      //   //    so we should send undefined for others
      //   p.deliveryDate = 0;
      //   p.deliveryDateExactly = false;
      // }
      // else if (json.checkDates[p.partNum - 1] && !json.dates[p.partNum - 1]) {
      //   // if checkDate is set but date is not,
      //   //     user can set all fields but
      //   //      if he set paymentDays, he can't change others
      //   if (p.deliveryDays || p.deliveryDaysExactly) {
      //     p.deliveryDate = 0;
      //     p.deliveryDateExactly = false;
      //   }
      // }
      // else if (json.checkDates[p.partNum - 1] && json.dates[p.partNum - 1]) {
      //   // if checkDate and date are set, user can change nothing
      //   p.deliveryDate = 0;
      //   p.deliveryDateExactly = false;
      //   p.deliveryDays = 0;
      //   p.deliveryDaysExactly = false;
      // }
      //
      // if (!json.checkDates[p.partNum - 1] && !json.receiveDates[p.partNum - 1]) {
      //   // if checkDate and date are not set, user can only set deliveryDays & deliveryDaysExactly,
      //   //    so we should send undefined for others
      //   p.receiveDate = 0;
      //   p.receiveDateExactly = false;
      // }
      // else if (json.checkDates[p.partNum - 1] && !json.receiveDates[p.partNum - 1]) {
      //   // if checkDate is set but date is not,
      //   //     user can set all fields but
      //   //      if he set paymentDays, he can't change others
      //   if (p.deliveryDays || p.deliveryDaysExactly) {
      //     p.receiveDate = 0;
      //     p.receiveDateExactly = false;
      //   }
      // }
      // else if (json.checkDates[p.partNum - 1] && json.receiveDates[p.partNum - 1]) {
      //   // if checkDate and date are set, user can change nothing
      //   p.receiveDate = 0;
      //   p.receiveDateExactly = false;
      //   p.deliveryDays = 0;
      //   p.deliveryDaysExactly = false;
      // }
    });

    return json;
  }
}

export default {
  state: {
    retend: {}
  },

  mutations: {
    setRetend(s, data) {
      const model = RetendModel.fromAPI(data);
      Vue.set(s.retend, [model.lot.id, model.num], model);
    },
  },

  getters: {
    retend: s => (lotId, retendNum) => s.retend[[lotId, retendNum]]
  },

  actions: {
    async handleRetend({dispatch, commit, getters}, data) {
      const deltaTime = +data.now - Date.now();
      await dispatch('fetchLot', { lotId: data.lotId });
      commit('setRetend', {
        retend: data,
        lot: getters.lot(data.lotId),
        deltaTime
      });
    },

    async baseRetendRequest({dispatch}, {method, url, data}) {
      let error;

      try {
        const response = await api[method](url, data);
        const {status, errorCode, result} = response.data;

        if (status === 200) {
          await dispatch('handleRetend', result);
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch (e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async fetchRetend({dispatch}, { lotId, retendNum }) {
      let error;
      try {
        const response = await api.get(`/lots/${lotId}/retend/${retendNum}`);
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          await dispatch('handleRetend', result);
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async saveRetend({dispatch, getters}, retend) {
      let error;

      try {
        const response = await api.put(`/lots/${retend.lot.id}/retend`, retend.toAPI()  );

        const { status, result, errorCode } = response.data;

        if (status === 200) {
          await dispatch('handleRetend', result);
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async getRetendSigningText({}, { lotId }) {
      let error;

      try {
        const response = await api.get(`lots/${lotId}/sign/retend`);
        const {status, errorCode, result} = response.data;

        if (status === 200) {
          return result;
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch (e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async signRetend({dispatch}, { lotId, text, signature }) {
      let error;

      try {
        const response = await api.put(`/lots/${lotId}/retend/commit`, {
          dataForSign: text,
          sign: signature
        });
        const {status, errorCode, result} = response.data;

        if (status === 200) {
          await dispatch('handleRetend', result);
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch (e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async acceptRetend({dispatch}, { lotId, accepted, reason }) {
      let error;

      try {
        const response = await api.put(`/lots/${lotId}/retend/accept/${!!accepted} `, {
          reason: !accepted ? reason : undefined
        });
        const {status, errorCode, result} = response.data;

        if (status === 200) {
          await dispatch('handleRetend', result);
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch (e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async cancelActiveRetend({dispatch}, { lotId }) {
      return await dispatch('baseRetendRequest', {
        method: 'post',
        url: `/lots/${lotId}/changeRetend/Closed/0`
      });
    },

    async editActiveRetend({dispatch}, { lotId }) {
      return await dispatch('baseRetendRequest', {
        method: 'post',
        url: `/lots/${lotId}/changeRetend/Draft/0`
      });
    },

    async changeActiveRetendStartDate({dispatch}, { lotId, date }) {
      return await dispatch('baseRetendRequest', {
        method: 'post',
        url: `/lots/${lotId}/changeRetend/Registred/${api.Date.toAPI(date, 0)}`
      });
    }
  }
}
